import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StatisticCard from "../../shared/components/StatisticCard";
import { formatPrice } from "../../shared/functions/formatPrice";
import { getClientStatusIcon } from "../../shared/functions/getClientStatusIcon";
import { getInvoiceStatusIcon } from "../../shared/functions/getInvoiceStatusIcon";
import { handleError } from "../../shared/functions/handleError";
import { IInvoiceStatistics } from "../../shared/interfaces/invoice/IInvoice";
import { IUserStatistic } from "../../shared/interfaces/user/IUser";
import InvoiceStatisticsSkeleton from "../invoice/components/InvoiceStatisticsSkeleton";
import { UserService } from "../user/service";

const AdminDashboard = () => {
  const { t } = useTranslation();
  const [statisticCards, setStatisticCards] = useState<
    IUserStatistic | undefined
  >(undefined);
  useEffect(() => {
    UserService.getDashboard().then(setStatisticCards).catch(handleError);
  }, []);
  return (
    <div>
      {statisticCards === undefined ? (
        <InvoiceStatisticsSkeleton />
      ) : (
        <Grid container spacing={2} sx={{ mb: "20px" }}>
          {Object.keys(statisticCards?.clients)?.map((statistic) => {
            return (
              <StatisticCard
                key={statistic}
                isSelected={
                  statistic === "pending" &&
                  Number(statisticCards?.clients?.pending) > 0
                }
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 3,
                }}
                getTitle={(item) => `${t(`client.status.${item}`)} Clients`}
                getIcon={(item) => getClientStatusIcon(item as string)}
                title={statistic}
                getValue={(item) =>
                  String(
                    statisticCards?.clients[
                      item as keyof typeof statisticCards.clients
                    ],
                  )
                }
              />
            );
          })}
          <StatisticCard
            size={{
              xs: 12,
              sm: 6,
              lg: 3,
            }}
            getTitle={(item) => t(`statistic.${item}`)}
            getIcon={(item) =>
              getInvoiceStatusIcon(item as keyof IInvoiceStatistics)
            }
            title={`totalUsers`}
            getValue={() => String(statisticCards?.totalUsers ?? 0)}
          />
          {Object.keys(statisticCards?.invoices)?.map((statistic) => {
            return (
              <StatisticCard
                key={statistic}
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 3,
                }}
                getTitle={(item) => `${t(`invoice.status.${item}`)} Invoices`}
                getIcon={(item) =>
                  getInvoiceStatusIcon(item as keyof IInvoiceStatistics)
                }
                title={statistic}
                getValue={(item) =>
                  String(
                    statisticCards?.invoices[
                      item as keyof typeof statisticCards.invoices
                    ],
                  )
                }
              />
            );
          })}
          {Object.keys(statisticCards?.earning)?.map((statistic) => {
            return (
              <StatisticCard
                key={statistic}
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 3,
                }}
                getTitle={(item) => t(`statistic.${item}`)}
                getIcon={(item) =>
                  getInvoiceStatusIcon(item as keyof IInvoiceStatistics)
                }
                title={statistic}
                getValue={(item) =>
                  String(
                    formatPrice(
                      statisticCards?.earning[
                        item as keyof typeof statisticCards.earning
                      ],
                    ),
                  )
                }
              />
            );
          })}
        </Grid>
      )}
    </div>
  );
};

export default AdminDashboard;
